/* eslint-disable @next/next/no-img-element */
import { Input, Modal } from 'antd'
import router, { NextRouter, useRouter } from 'next/router'
import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ButtonMain } from '../Button/ButtonMain/ButtonMain'
import { SearchResult } from './SearchResult'
import { motion } from 'framer-motion'
import { useQueryClient } from 'react-query'

type SearchBoxProps = {
  router: NextRouter
}
export const SearchBox = (props: SearchBoxProps) => {
  const { router } = props
  const [searchValue, setSearchValue] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [isFocus, setIsFocus] = useState(false)
  const queryClient = useQueryClient()
  const inputRef = React.useRef<any>(null)

  useEffect(() => {
    if (openModal === false) {
      setSearchValue('')
      setIsFocus(false)
    } else {
      // Focus vào input khi modal mở
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [openModal])

  const handleOpen = () => {
    setOpenModal(true)
    queryClient.setQueryData<boolean>('miniCartVisible', false)
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  useEffect(() => {
    setOpenModal(false)
  }, [router.asPath])

  const onSubmit = () => {
    setSearchValue('')
    router.push({
      pathname: '/result-search',
      query: {
        currentPage: 1,
        pageSize: 20,
        search: `${searchValue}`.trim(),
      },
    })
  }

  return (
    <>
      <button
        className="icon-search max-md:bg-[#e7e5e5] max-md:rounded-full max-md:w-[3.6rem] max-md:h-[3.6rem] max-md:flex max-md:items-center max-md:justify-center max-md:flex-shrink-0"
        onClick={handleOpen}
      >
        <div className="img min-w-[12px] w-[2rem] max-md:p-[0.4rem]" onClick={() => handleClose}>
          <img src={'/image/svg/search.svg'} alt="" className="w-full text-white" />
        </div>
      </button>
      <Modal
        className="wrapper-modal-search"
        style={{ top: 0 }}
        visible={openModal}
        wrapClassName={`fade-modal ${openModal ? 'modal-open' : ''}`}
        onCancel={handleClose}
        footer={null}
        width={'100vw'}
        closable={false}
        transitionName="fade"
        maskTransitionName="fade"
      >
        <div>
          <div className="image-box flex xl:text-[6rem] lg:text-[4rem] text-[3.2rem] items-center max-md:justify-between">
            <img src="/image/logo/logo-footer.png" alt="" className="w-[3em]" />

            <div className="w-[.5em] h-[.5em] cursor-pointer " onClick={() => handleClose()}>
              <img
                src="/image/close.png"
                alt=""
                className="filter-white w-full h-full transition-transform duration-300 hover:rotate-180"
              />
            </div>
          </div>
          <p className="title-search">Bạn đang tìm gì?</p>
          <div className="wrapper-box-search">
            <div className="w-full xl:w-fit flex lg:gap-[3rem] gap-[1.6rem] justify-center relative ">
              <Input
                ref={inputRef}
                // prefix={<img src="/icons/search-icon.svg" alt="" />}
                prefix={<img src="/icons/search-icon.svg" alt="" />}
                placeholder="Nhập tên sản phẩm, thương hiệu,..."
                onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
                value={searchValue}
                onChange={(event) => {
                  setSearchValue(event.target.value)
                }}
                onFocus={() => setIsFocus(true)}
              />
              <div className="button-search">
                <ButtonMain
                  background="green"
                  type="button"
                  className="rounded-[6px!important] h-[44px] z-10"
                  onClick={onSubmit}
                >
                  <div className="flex items-center gap-[0.4rem]">
                    <div className="icon">
                      <img src="/icons/search-icon.svg" alt="" />
                    </div>
                    <div className="text max-lg:hidden">Tìm kiếm</div>
                  </div>
                </ButtonMain>
                {isFocus && searchValue && (
                  <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: 'auto' }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.3, ease: [0.33, 1, 0.68, 1] }}
                  >
                    <SearchResult setSearchValue={setSearchValue} searchValue={searchValue} />
                  </motion.div>
                )}
              </div>
            </div>
          </div>

          <div className="wrapper-image">
            <img src="/image/car-search-modal.png" alt="" />
          </div>
        </div>
      </Modal>
    </>
  )
}
